import { CurrencyIcon } from '@components'
import { MerchantAccessLevels, useCurrencies } from 'mmfintech-backend-api'
import { formatMoney, tr } from 'mmfintech-commons'
import './AccountOverviewRow.scss'

interface Props {
  account: {
    id: number
    currencyCode: string
    balance: number
    name: string
    permission?: string
  }
}

function AccountOverviewRow({ account }: Props) {
  const { currencyCode, balance, name, permission } = account

  const { getCurrencyPrecision } = useCurrencies()

  return (
    <div className='account-overview-row'>
      <div className='cell'>
        <CurrencyIcon currency={currencyCode} size='3.4rem' className='mr-1 currency-icon' />
      </div>
      <div className='cell'>
        <span className='title'>{tr('PORTAL.DASHBOARD.ACCOUNT_OVERVIEW.CURRENCY', 'Currency')}</span>
        <span>{currencyCode}</span>
      </div>
      <div className='cell'>
        <span className='title'>{tr('PORTAL.DASHBOARD.ACCOUNT_OVERVIEW.ACCOUNT_NAME', 'Account name')}</span>
        <span className='subtitle'>{name}</span>
      </div>
      <div className='cell'>
        <span className='title'>{tr('PORTAL.DASHBOARD.ACCOUNT_OVERVIEW.PERMISSIONS', 'Permissions')}</span>
        <span className='subtitle'>
          {permission === MerchantAccessLevels.WRITER
            ? tr('PORTAL.DASHBOARD.ACCOUNT_OVERVIEW.FULL_ACCESS', 'Full')
            : tr('PORTAL.DASHBOARD.ACCOUNT_OVERVIEW.VIEW_ONLY', 'View only')}
        </span>
      </div>
      <div className='cell'>
        <span className='title'>{tr('PORTAL.DASHBOARD.ACCOUNT_OVERVIEW.BALANCE', 'Balance')}</span>
        <span className='subtitle'>
          {formatMoney(balance || 0, currencyCode || '', getCurrencyPrecision(currencyCode))}
        </span>
      </div>
    </div>
  )
}

export default AccountOverviewRow
